import { Card } from "@/components/ui/card";
import { Shield, Lock, Eye, Database, Globe, UserCheck, Cookie } from "lucide-react";

const Privacy = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <div className="flex items-center gap-3 mb-8">
        <Shield className="h-8 w-8 text-primary" />
        <h1 className="text-3xl font-bold">Privacy Policy</h1>
      </div>
      
      <Card className="p-6 space-y-6">
        <section>
          <div className="flex items-center gap-2 mb-3">
            <Database className="h-5 w-5 text-primary" />
            <h2 className="text-xl font-semibold">Information We Collect</h2>
          </div>
          <p className="text-muted-foreground mb-3">
            We collect information you provide directly to us, including:
          </p>
          <ul className="list-disc list-inside text-muted-foreground space-y-1 ml-4">
            <li>Name, email address, and phone number</li>
            <li>Billing and shipping address</li>
            <li>Payment information</li>
            <li>Product preferences and purchase history</li>
            <li>Communication preferences</li>
          </ul>
        </section>

        <section>
          <div className="flex items-center gap-2 mb-3">
            <Eye className="h-5 w-5 text-primary" />
            <h2 className="text-xl font-semibold">How We Use Your Information</h2>
          </div>
          <p className="text-muted-foreground">
            We use the information we collect to:
          </p>
          <ul className="list-disc list-inside text-muted-foreground space-y-1 ml-4 mt-2">
            <li>Process transactions and send related information</li>
            <li>Send administrative information and updates</li>
            <li>Respond to comments, questions, and requests</li>
            <li>Send marketing and promotional communications</li>
            <li>Improve and personalize user experience</li>
          </ul>
        </section>

        <section>
          <div className="flex items-center gap-2 mb-3">
            <Lock className="h-5 w-5 text-primary" />
            <h2 className="text-xl font-semibold">Data Security</h2>
          </div>
          <p className="text-muted-foreground">
            We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. All payment transactions are encrypted using SSL technology.
          </p>
        </section>

        <section>
          <div className="flex items-center gap-2 mb-3">
            <Globe className="h-5 w-5 text-primary" />
            <h2 className="text-xl font-semibold">Information Sharing</h2>
          </div>
          <p className="text-muted-foreground">
            We do not sell, trade, or rent your personal information to third parties. We may share your information with:
          </p>
          <ul className="list-disc list-inside text-muted-foreground space-y-1 ml-4 mt-2">
            <li>Service providers who assist in our operations</li>
            <li>Law enforcement when required by law</li>
            <li>Other parties with your consent</li>
          </ul>
        </section>

        <section>
          <div className="flex items-center gap-2 mb-3">
            <Cookie className="h-5 w-5 text-primary" />
            <h2 className="text-xl font-semibold">Cookies, Advertising &amp; Measurement</h2>
          </div>
          <p className="text-muted-foreground mb-3">
            We use cookies and similar technology to keep your cart and sign-in working, and — only
            where you allow it — to measure visits to our site and how well our advertising
            performs. Two advertising platforms are involved:
          </p>
          <ul className="list-disc list-inside text-muted-foreground space-y-1 ml-4">
            <li>
              <strong>Meta</strong> (Facebook and Instagram) — Meta Pixel
            </li>
            <li>
              <strong>TikTok</strong> — TikTok Pixel
            </li>
          </ul>
          <p className="text-muted-foreground mt-3 mb-3">
            Where these tags are enabled, they receive information about your browser and device,
            the pages of our site you visit, the coarse location derived from your IP address, and
            how you interact with ads shown on those platforms. We use that for two purposes only:
            measuring activity, and improving or optimising our advertising. We do not send your
            name, email address or phone number to either platform for advertising without your
            consent.
          </p>
          <p className="text-muted-foreground mb-3">
            Visitors in regions that require consent (the EEA, the UK, EEA-EFTA states and
            Switzerland), and anyone whose country cannot be determined, are asked before any
            advertising tag is loaded, and nothing runs until they accept. Elsewhere advertising
            tags run without a prompt, and applicable opt-outs are honoured.
          </p>
          <p className="text-muted-foreground">
            You can refuse at the prompt, or change or withdraw your choice at any time using the
            <strong>Cookie settings</strong> link in the footer of every page. Your choice is stored
            with the date it was made and the wording you were shown; withdrawing is recorded as a
            new refusal, and the platforms stop receiving new events straight away. You also have
            the right to object to this processing.
          </p>
        </section>

        <section>
          <div className="flex items-center gap-2 mb-3">
            <UserCheck className="h-5 w-5 text-primary" />
            <h2 className="text-xl font-semibold">Your Rights</h2>
          </div>
          <p className="text-muted-foreground">
            You have the right to:
          </p>
          <ul className="list-disc list-inside text-muted-foreground space-y-1 ml-4 mt-2">
            <li>Access and update your personal information</li>
            <li>Request deletion of your account</li>
            <li>Opt-out of marketing communications</li>
            <li>Request a copy of your data</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">Contact Us</h2>
          <p className="text-muted-foreground">
            If you have questions about this Privacy Policy, please contact us at:
          </p>
          <p className="text-muted-foreground mt-2">
            Email: privacy@sabitradeng.com<br />
            Phone: +234 800 000 0000
          </p>
        </section>

        <section>
          <p className="text-sm text-muted-foreground italic">
            Last updated: October 2026
          </p>
        </section>
      </Card>
    </div>
  );
};

export default Privacy;